// Reads a File's raw contents as text. Shared by fileToText.js (which
// splits the result into lines for CSV parsing) and fileToJson.js (which
// keeps it intact so multi-line JSON parses correctly) — one FileReader
// implementation, two purpose-built call sites.
const readFileAsText = (file) =>
  new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = () =>
      reject(fileReader.error || new Error('Failed to read file'));
    fileReader.readAsText(file);
  });

export default readFileAsText;
